import { z } from "zod";
import { PAYMENT_METHODS } from "../types";

export const customerCheckoutSchema = z.object({
  phone: z.string().min(7, "Phone number is required"),
  deliveryLocation: z.string().min(3, "Delivery location is required"),
  paymentMethod: z.enum(PAYMENT_METHODS),
});

export type CustomerCheckoutFormValues = z.infer<typeof customerCheckoutSchema>;
